import axios from '@/plugins/http.js'

export const checkToken = token => {
  return axios.get(`/api/v1/register-tokens/${token}`)
}

export const deleteToken = token => {
  return axios.delete(`/api/v1/register-tokens/${token}`)
}
